<app-damage-report-step-header />
<div class="damage-report-card">
    <form [formGroup]="form">
        <div class="grid-container">
            <div class="form-control g-12">
                <label for="damage-description">Beschreibung des Schadens*</label>
                <textarea
                    autoresize
                    id="damage-description"
                    formControlName="damageDescription"
                    placeholder="Beschreibung des Schadens*"
                ></textarea>
                @if (form.controls.damageDescription.touched && form.controls.damageDescription.invalid) {
                    @if (form.controls.damageDescription.errors.required) {
                        <span
                            class="form-error-note"
                            aria-live="polite"
                            >Bitte gib die Beschreibung des Schadens an.</span
                        >
                    }
                }
            </div>

            <div class="form-control g-12">
                <label for="event-description">Wie kam es zu dem Schaden?</label>
                <textarea
                    autoresize
                    id="event-description"
                    formControlName="eventDescription"
                    placeholder="Wie kam es zu dem Schaden?"
                ></textarea>
            </div>
        </div>

        <app-required-info />

        <app-portal-action-buttons
            (clickReject)="onPrev.emit()"
            (clickConfirm)="onNext.emit()"
            [isConfirmDisabled]="!canGoToNextStep()"
            [isUsedToSubmitForm]="true"
        />
    </form>
</div>
